import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';
import type { BackendLongFormAsset, BackendQuerySavedLongFormAssetArgs } from 'src/types/backend';

const QUERY = gql`
  query SavedLongFormAsset($id: ID!) {
    savedLongFormAsset(id: $id) {
      id
      contentHtml
      score
    }
  }
`;

type Variables = BackendQuerySavedLongFormAssetArgs;
type Result = Pick<BackendLongFormAsset, 'id' | 'contentHtml' | 'score'>;

/** A long-form item as it is saved, read without changing it. */
export const querySavedLongFormAsset = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  throwIfResultHasErrors(result);
  return getSingleProp<Result>(result.data) ?? null;
};
